{
  "name": "wherobots-sql-driver",
  "version": "0.12.0",
  "description": "TypeScript SDK for Wherobots DB",
  "license": "Apache-2.0",
  "main": "./dist/node/index.js",
  "module": "./dist/node/index.mjs",
  "browser": "./dist/browser/index.js",
  "types": "./dist/node/index.d.ts",
  "exports": {
    ".": {
      "browser": {
        "types": "./dist/browser/index.d.ts",
        "import": "./dist/browser/index.mjs",
        "require": "./dist/browser/index.js"
      },
      "node": {
        "types": "./dist/node/index.d.ts",
        "import": "./dist/node/index.mjs",
        "require": "./dist/node/index.js"
      },
      "default": {
        "types": "./dist/node/index.d.ts",
        "import": "./dist/node/index.mjs",
        "require": "./dist/node/index.js"
      }
    }
  },
  "files": [
    "dist"
  ],
  "keywords": [
    "wherobots",
    "sedona",
    "geospatial",
    "spatial sql"
  ],
  "homepage": "https://github.com/wherobots/wherobots-typescript-sdk",
  "bugs": "https://github.com/wherobots/wherobots-typescript-sdk/issues",
  "repository": {
    "type": "git",
    "url": "https://github.com/wherobots/wherobots-typescript-sdk"
  },
  "engines": {
    "node": ">=18.0.0"
  },
  "scripts": {
    "build": "tsup",
    "build:check": "tsc --noEmit",
    "lint": "eslint .",
    "lint:fix": "eslint . --fix",
    "format": "prettier --check .",
    "format:fix": "prettier --write .",
    "prepare": "husky",
    "prepublish": "npm run build",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:browser": "playwright test"
  },
  "devDependencies": {
    "@commitlint/cli": "^19.4.0",
    "@commitlint/config-conventional": "^19.2.2",
    "@playwright/test": "^1.49.0",
    "@swc-node/register": "^1.10.9",
    "@tsconfig/node-lts": "^20.1.3",
    "@tsconfig/strictest": "^2.0.5",
    "@types/ws": "^8.5.12",
    "@typescript-eslint/eslint-plugin": "^7.18.0",
    "@typescript-eslint/parser": "^7.18.0",
    "eslint": "^8.57.0",
    "eslint-config-airbnb": "^19.0.4",
    "eslint-config-airbnb-typescript": "^18.0.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-node": "^11.1.0",
    "eslint-plugin-prettier": "^5.2.1",
    "eslint-plugin-security": "^3.0.1",
    "esbuild": "^0.28.1",
    "husky": "^9.1.4",
    "lint-staged": "^15.2.9",
    "prettier": "^3.3.3",
    "tsup": "^8.3.5",
    "typescript": "^5.5.4",
    "vitest": "^3.0.5",
    "vitest-fetch-mock": "^0.3.0"
  },
  "dependencies": {
    "apache-arrow": "^17.0.0",
    "cbor-x": "^1.6.0",
    "pino": "^9.3.2",
    "pino-pretty": "^11.2.2",
    "uuid": "^11.1.1",
    "ws": "^8.18.0",
    "zod": "^3.23.8"
  },
  "overrides": {
    "tsup": {
      "esbuild": "^0.28.1"
    }
  }
}
